webpackJsonp([75380137873186],{

/***/ 1455:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"InvoiceLineItemReasonInput","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"isActive","type":{"kind":"SCALAR","name":"Boolean","ofType":null}},{"defaultValue":null,"description":null,"name":"name","type":{"kind":"SCALAR","name":"String","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---input-object-invoice-line-item-reason-input-f53837fa38ea8cc6fba7.js